import { createFileRoute, notFound } from '@tanstack/react-router';
import { isValidSubNav, isValidType, type SubnavParam, type TypeParam } from './-utils';

type SearchParams = {
  seedId?: string;
  copyAudience?: boolean;
  templateId?: string;
  isSystemTemplate?: boolean;
  isEdit?: boolean;
};

type Params = {
  subNav: SubnavParam;
  type: TypeParam;
  id: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/bulk_/$subNav_/$type_/$id')({
  params: {
    parse: (params): Params => {
      if (!isValidType(params.type)) {
        throw notFound();
      }
      if (!isValidSubNav(params.subNav)) {
        throw notFound();
      }
      if (!params.id) {
        throw notFound();
      }
      return {
        ...params,
        id: params.id,
        subNav: params.subNav,
        type: params.type,
      };
    },
  },
  validateSearch: (search: Partial<SearchParams>): SearchParams => {
    return {
      seedId: search.seedId,
      copyAudience: search.copyAudience,
      templateId: search.templateId,
      isSystemTemplate: search.isSystemTemplate,
      isEdit: search.isEdit,
    };
  },
});
